import { useSelector } from 'react-redux'
import { Box, Button } from '@vp/swan'

import { ClearAllRefinementsTextButton } from '~/app/features/Gallery/components/ClearAllRefinementsTextButton'
import { findAllRemovableRefinements } from '~/app/features/Gallery/components/Subheader/RefinementsList/findAllRemovableRefinements'
import { useTranslations } from '~/app/features/Gallery/hooks/useTranslations'

export interface PropTypes {
  onClose: (event: React.MouseEvent<HTMLButtonElement>) => void
}

/**
 * Mobile Filter Menu
 * @param props
 */
export const FilterMenuFooter = (props: PropTypes) => {
  const { onClose } = props
  const localize = useTranslations()
  const refinements = useSelector(findAllRemovableRefinements)

  return (
    <Box className="filter-menu-footer" mb={0}>
      <ClearAllRefinementsTextButton refinements={refinements} width="full-width" />
      <Button skin="primary" width="full-width" onClick={onClose}>
        {localize('FilterMenuDoneButtonText')}
      </Button>
    </Box>
  )
}

FilterMenuFooter.displayName = 'FilterMenuFooter'
